import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Finutss = () => {
  useEffect(() => {
    // App carousel slider
    const slider = document.getElementById("slider");
    if (!slider) return;

    let currentIndex = 0;
    const slides = slider.children;
    const totalSlides = slides.length;

    const slide = () => {
      if (totalSlides > 0) {
        currentIndex = (currentIndex + 1) % (totalSlides - 2);
        slider.style.transform = `translateX(-${currentIndex * 33.333}%)`;
      }
    };

    const slideInterval = setInterval(slide, 3000);

    return () => {
      clearInterval(slideInterval);
    };
  }, []);

  return (
    <div className="finutss-page portfolio-details-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeIn" data-wow-delay="0.5s">
            <h1>
              <img src="/assets/images/logos/logo-finutss-1.svg" alt="finutss" />
            </h1>
            <h2>Everyone's Social Home Training</h2>
            <div className="breadcrumb">
              <span>
                Portfolio / <strong>Finutss</strong>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="whatwedo-section">
        <div className="container">
          <div className="row">
            <div className="col col-4">
              <h2>What We Did</h2>
              <ul className="list">
                <li>UX & UI Design</li>
                <li>Product Architecture</li>
                <li>Mobile Development</li>
                <li>Backend Development</li>
                <li>Security</li>
              </ul>
            </div>
            <div className="col col-8">
              <h2>Overview</h2>
              <p>
                Finutss is a fitness app designed for indoor bikes and treadmills, offering users a unique and
                engaging home training experience. It utilizes real geographic information to create virtual
                exercise routes, allowing users to explore new locations and enjoy diverse workout paths.
              </p>
              <p>
                What sets Finutss apart is its emphasis on social connectivity. Users can exercise, chat, and
                make friends in real time, transforming their workouts into a shared experience. Whether it's
                friendly competition or collaborative challenges, Finutss fosters a sense of community and
                motivation.
              </p>
              <p>
                Setting up Finutss is quick and easy. By attaching a Bluetooth sensor to their exercise
                equipment, such as pedal bikes or treadmills, users can seamlessly connect to the app and start
                their workouts right away. With Finutss, users can enjoy personalized workouts, social
                interaction, and a sense of adventure from the comfort of their own homes.
              </p>
            </div>
          </div>
          <div className="portfolio-carousel" id="slider">
            <div className="slide-content">
              <img
                src="/assets/images/background/finutzz/main.png"
                alt="finutss-main"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="challenges-section">
        <div className="container">
          <div className="challenges">
            <div className="col col-6">
              <div className="img-card">
                <img src="/assets/images/background/finutzz/m1.webp" alt="finutss" />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Challenges</h3>
                <div className="scroll">
                  <p>
                    During the development of Finutss, our team encountered several challenges. Firstly,
                    testing the code posed difficulties due to the involvement of sensors. This required
                    extensive testing during the development phase, which took additional time for
                    developers to ensure the accuracy and reliability of the sensor data.
                  </p>
                  <p>
                    Additionally, there were technical hurdles to overcome. Integrating JavaScript libraries
                    into the Flutter framework and making multiple API calls presented challenges that
                    required careful coordination and troubleshooting. Managing multiple media elements at
                    different points along the exercise route was also a complex task that required
                    meticulous attention to detail.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-6 flex-reverse">
              <div className="img-card">
                <img src="/assets/images/background/finutzz/m3.png" alt="finutss-m3" />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Solutions</h3>
                <div className="scroll">
                  <p>
                    For the challenge of testing the code involving sensors, we allocated dedicated time and
                    resources for thorough testing. This allowed us to ensure the accuracy and reliability
                    of the sensor data, resulting in a more robust and reliable user experience.
                  </p>
                  <p>
                    Throughout the development process, our team remained committed to proactive
                    problem-solving, conducting thorough testing and collaborating closely to address any
                    issues that arose. By adopting a meticulous approach and leveraging the expertise of our
                    developers, we successfully overcame the challenges and delivered a high-quality,
                    feature-rich app in the form of Finutss.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section">
        <div className="container">
          <div className="title">
            <h2>Browse on any device</h2>
            <p>
              Experience responsive, pixel-perfect UI designs on any device with our custom software solutions
            </p>
          </div>
          <div className="app-carousel" id="slider">
            <div className="slide-content">
              <img src="/assets/images/background/finutzz/s1.webp" alt="finutss-1" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/finutzz/s2.webp" alt="finutss-2" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/finutzz/s3.webp" alt="finutss-3" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/finutzz/s4.webp" alt="finutss-4" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/finutzz/s5.webp" alt="finutss-5" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/finutzz/s6.webp" alt="finutss-6" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/finutzz/s7.webp" alt="finutss-7" />
            </div>
          </div>
          <div className="download-app">
            <h2>Test Drive our Results</h2>
            <p>Experience the impact of our work firsthand</p>
            <div className="app-link">
              <a
                href="https://play.google.com/store/apps/details?id=com.finutss.metatrack.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/logos/logo-playstore.png"
                  alt="playstore"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="container">
          <div className="testimonial-carousel">
            <div className="slide-content">
              <div className="slide-info">
                <h3>
                  We were able to successfully complete the project by meeting the best partner. They have a
                  very good understanding of development and skills, and are fully committed to the task
                  schedule. The time we met and spent with them is lucky for us. We'll always work on the
                  project with them.
                </h3>
                <div className="flex">
                  <div className="client flex">
                    <div className="client-img">
                      <img
                        src="/assets/images/reviews/finutzz/user.jpg"
                        alt="client"
                      />
                    </div>
                    <div className="client-details">
                      <h4>Min Suk Kim</h4>
                      <h5>CEO, Nine Peace Co. Ltd.</h5>
                    </div>
                  </div>
                  <div className="logo-img">
                    <img
                      src="/assets/images/logos/logo-finutss-1.svg"
                      alt="finutss"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Finutss;
